<template>
 <div>
   <div class="searchBox" ref="searchBox">
      <el-form :inline="true"  class="demo-form-inline" label-width="110px" size="mini">
         <div class="searchBox inpBox1" style="margin-left:-20px;">
            <div class="item">
              <!-- <el-form-item label="委托方:" prop="demandTenantName">
                <el-input placeholder="" v-model="searchFrom.demandTenantName"></el-input>
              </el-form-item> -->
               <el-form-item label="提单号:" prop="demandNo">
                <el-input placeholder="" v-model="searchFrom.demandNo"></el-input>
              </el-form-item>
              <el-form-item label="指派状态:" prop="status">
                <el-select v-model="searchFrom.status" placeholder="请选择">
                  <el-option v-for="val in options" :label="val.name" :value="val.id" :key="val.id"></el-option>
                </el-select>
              </el-form-item>
            </div>
        </div>
        <div class="searchBtnBox">
          <el-form-item>
              <el-button type="primary" @click="searchFn">查询</el-button>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="resetForm('searchFrom')">重置</el-button>
            </el-form-item>
        </div>
      </el-form>
    </div>
    <!--  表格 -->
    <div class="table" :style="{height:h}">
      <el-table :data="tableList"  ref="table" v-loading="loading"   bordersize="mini"  @selection-change='selectGoods'
       @row-click="handleRowClick"  style="width: 100%" height="100%"  center border>
        <el-table-column type="index" prop="date" width="55" label="序号"></el-table-column>
         <el-table-column label="操作" width="160">
          <template slot-scope="scope">
            <div>
              <el-button type="text" size="mini"  v-if="scope.row.status==1002 && btnFlg[5]" @click="addClick(scope.row)">作废</el-button>
              <!-- <el-button type="text" size="mini" @click="yichangFn(scope.row)">合同</el-button> -->
            </div>
          </template>
        </el-table-column>
        <el-table-column label="提货单号"  width="240">
            <template slot-scope="scope">
              <span style="color: #0c46a2;cursor: pointer;" @click="detailFn(scope.row)">{{scope.row.demandNo}}</span>
            </template>
        </el-table-column>
        <el-table-column prop="status"  min-width="120" :formatter="demandOfferStatusFormat" label="指派状态"></el-table-column>
        <el-table-column prop="demandFinalDate"  min-width="160" :formatter="(row, column,cellValue,index) => dateTimeFormat(row, column,cellValue,index, 1)" label="指派截止时间"></el-table-column>
        <el-table-column prop="productTypeName"  min-width="170" :formatter="emptyFn" label="货物类型"></el-table-column>
        <el-table-column label="委托量" width="160">
          <template slot-scope="scope">
            <div>
              {{scope.row.productWeight}}吨/{{scope.row.productNum}}件
            </div>
          </template>
        </el-table-column>
        <el-table-column label="实提量" width="160">
          <template slot-scope="scope">
            <div>
              {{scope.row.actualWeight}}吨/{{scope.row.actualNum}}件
            </div>
          </template>
        </el-table-column>
        <el-table-column  prop="carriageName" min-width="170" :formatter="emptyFn" label="承运方"></el-table-column>
        <!-- <el-table-column prop="unitPrice"  min-width="170"  label="抢单价">
           <template slot-scope="scope">
            <div>
              {{scope.row.unitPrice}}{{scope.row.pricingMethod==1?'元/吨':'元'}}
            </div>
          </template>
        </el-table-column> -->
        <el-table-column label="发货信息" width="450">
          <template slot-scope="scope">
            <div class="box1">
              <span style="color:#0c46a2">(发){{scope.row.deliverCompany}}</span>
              <span>{{scope.row.deliverPerson}}</span>
            </div>
            <div class="box1">
              <span>{{scope.row.deliverPhone}}  </span>
              <span style="margin-left:10px">{{scope.row.deliverAddress}}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="收货信息" width="450">
          <template slot-scope="scope">
            <div class="box1">
              <span style="color:#F56C6C">(收){{scope.row.receivingCompany}}</span>
              <span>{{scope.row.receivingPerson}}</span>
            </div>
            <div class="box1">
              <span>{{scope.row.receivingPhone}}</span>
              <span style="margin-left:10px">{{scope.row.receivingAddress}}</span>
            </div>
          </template>
        </el-table-column>
       <el-table-column prop="hopeReceivingDate"  min-width="160" :formatter="(row, column,cellValue,index) => dateTimeFormat(row, column,cellValue,index, 1)" label="最晚提货时间"></el-table-column>
        <el-table-column prop="createUserName"  min-width="130" :formatter="emptyFn" label="创建人" show-overflow-tooltip></el-table-column>
        <el-table-column prop="createTime"  min-width="160" :formatter="dateTimeFormat" label="创建时间"></el-table-column>
      </el-table>
    </div>
     <!-- 分页 -->
    <div>
      <el-pagination background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="searchFrom.pageNo"
        :page-sizes="[50,100,200,1000]"
        :page-size="searchFrom.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>
    <el-dialog  title="结果"  :visible.sync="jieguoMark"  :close-on-click-modal="false" width="400px" center>
        <div style="">
          <div style="margin-bottom: 8px;">成交承运商：{{row.carriageName}}</div>
          <div>成交时间：{{dateFormatUtil('yyyy-MM-dd hh:ii',row.completeTime)}}</div>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="jieguoMark = false">取 消</el-button>
        </span>
      </el-dialog>
      <el-dialog :title="title"  :visible.sync="SQMark" width="450px" class="detail"  :close-on-click-modal="false" @close="closeDialog" :close-on-press-escape="false" center>
       <el-form :inline="true"  :model="SQFrom" ref="SQFrom" :rules="rules" class="demo-form-inline jiaoyan" label-width="145px" size="mini">
        <div class="inpBox1">
            <div style="margin: 28px 0;">
                <el-form-item label="作废原因:" prop="abandonedReason" style="margin-top:10px;">
                 <el-input type="textarea" v-model="SQFrom.abandonedReason"></el-input>
                </el-form-item>
             </div>
        </div>
        </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="SQMark = false">取消</el-button>
        <el-button type="primary" @click="SQsave()">确定</el-button>
      </span>
   </el-dialog>
 </div>
</template>

<script>
import { getBtn, getAttribute, getAttributeA } from '@/utils/getButton'
import { emptyFn, dateTimeFormat, dateFormat, dateFormatUtil } from '@/utils/util'
import { showBiddingResult } from '@/api/vgs-match'
import { apporintDemandList, cancelFindCarTypeEmptyBill } from '@/api/soc-stock'

export default {
  data () {
    return {
      options: [
        { name: '待接单', id: 1002 },
        { name: '已接单', id: 1203 },
        { name: '已派车', id: 1301 },
        { name: '已拒单', id: 1202 },
        { name: '审核中', id: 1000 },
        { name: '已作废', id: 1201 }

      ],
      title: '',
      h: 500,
      dateTimeFormat: dateTimeFormat,
      dateFormat: dateFormat,
      emptyFn: emptyFn,
      dateFormatUtil: dateFormatUtil,
      tableList: [],
      searchFrom: {
        pageNo: 1,
        pageSize: 50
      },
      total: 0,
      loading: false,
      jieguoMark: false,
      row: {},
      btnFlg: [],
      btnIdArr: ['00UM090100', '00UM090200', '00UM090300', '00UM090400', '00UM090500', '00UM090600'],
      rules: {
        abandonedReason: [
          { required: true, message: '请输入作废原因', trigger: 'blur' }
        ]
      },
      SQFrom: {
      },
      SQMark: false,
      tableArr: [],
      janFaFlag: null
    }
  },
  created () {
    this.btnFlg = getBtn(this.btnIdArr, '/searchCarJY')
    this.tableArr = getAttribute('ARRoneCustomerName,ARRownerCustomerName,ARRisCarHold,ARRvalidityTime,ARRdriverIdentityNo')
    this.warehouseList = [{
      relTenantName: localStorage.getItem('createTenantName'),
      relTenantCode: localStorage.getItem('createTenantCode')
    }]
    this.$set(this.searchFrom, 'organizationId', this.warehouseList[0].relTenantCode)
    getAttributeA('ARRisSelfWarehouse', this.warehouseList[0].relTenantCode).then(res => {
      console.log(res)
      if (res[0] == 3) { // 是建发库
        this.janFaFlag = 1
      }
      this.getList(this.searchFrom)
    })
  },
  mounted () {
    let h = this.$refs.searchBox.offsetHeight
    let pH = document.documentElement.clientHeight
    this.h = (pH - h - 98) + 'px'
  },
  methods: {
    // 详情
    detailFn (row) {
      this.$router.push({ name: 'detailsALL', query: { id: row.id } })
      // this.$router.push({ name: 'MlookGoodsDetails', query: { id: row.demandId, status: row.demandOfferStatus } })
    },
    // 结果
    jieguoFn (row) {
      showBiddingResult({ demandId: row.demandId, offerFlag: 1 }).then(res => {
        this.jieguoMark = true
        this.row.carriageName = res.carriageName
        this.row.completeTime = res.completeTime
      }).catch(error => {
        this.$message({
          showClose: true,
          message: error.message,
          type: 'error',
          onClose () {
          }
        })
      })
    },
    // 查选
    searchFn () {
      this.getList(this.searchFrom)
    },
    // 选择数据
    selectGoods (selection) {
    },
    // 点击选中
    handleRowClick (row, column, event) {
      this.$refs.table.toggleRowSelection(row)
    },
    // 获取列表
    getList () {
      this.loading = true
      apporintDemandList(this.searchFrom).then(res => {
        this.loading = false
        this.tableList = res.list
        this.total = res.total
      }).catch(error => {
        this.loading = false
        this.$message({
          message: error.message,
          type: 'error'
        })
      })
    },
    // 每页条数
    handleSizeChange (val) {
      this.searchFrom.pageSize = val
      this.getList(this.searchFrom)
    },
    // 当前页
    handleCurrentChange (val) {
      this.searchFrom.pageNo = val
      this.getList(this.searchFrom)
    },
    // 重置
    resetForm (formName) {
      // debugger
      this.searchFrom = {
        pageNo: 1,
        pageSize: 50
      }
    },
    // 状态格式化
    demandOfferStatusFormat (row, column, cellValue) {
      switch (cellValue) {
        case 1002:
          return '待接单'
        case 1202:
          return '已拒单'
        case 1203:
          return '已接单'
        case 1301:
          return '已派车'
        case 1000:
          return '审核中'
        case 1201:
          return '已作废'
      }
    },
    // 作废
    addClick (row) {
      this.title = '作废'
      this.SQMark = true
      this.SQFrom.billNo = row.demandNo
    },
    SQsave () {
      this.$refs.SQFrom.validate((valid) => {
        if (valid) {
          const loading = this.$loading({
            lock: true,
            text: '正在处理...'
          })
          cancelFindCarTypeEmptyBill(this.SQFrom).then(res => {
            loading.close()
            this.$message({
              message: '作废成功',
              type: 'success'
            })
            this.SQMark = false
            this.getList(this.searchFrom)
          }).catch(error => {
            this.$message({
              showClose: true,
              message: error.message,
              type: 'error',
              onClose () {
                loading.close()
              }
            })
          })
        }
      })
    },
    closeDialog () {
      this.SQFrom = {
      }
    }
  }
}
</script>

<style scoped lang='less'>
.searchBtnBox {
  margin-left: 10px;
}
.inpBox1 .el-date-editor{
  width: 350px!important;
}
/deep/ .checkboxBox{
  display: flex;
  label{
    flex-shrink: 0;
  }
  .el-checkbox-group{
    width:250px ;
  }
}
.jiage .el-form-item__content {
  position: relative;
  .identiCode1 {
    position: absolute;
    right: 14px;
    color: #409eff;
  }
  .danwei1 {
    position: absolute;
    right: 14px;
    color: white;
    padding: 7px 4px;
  }
}
/deep/.inpBox1 .el-input__inner {
    width: 180px;
}
</style>
